import { render, staticRenderFns } from "./ContributionDeclarationPage.vue?vue&type=template&id=58201af4&scoped=true&"
import script from "./ContributionDeclarationPage.vue?vue&type=script&lang=js&"
export * from "./ContributionDeclarationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58201af4",
  null
  
)

export default component.exports